/**
 * Utility para logging con control de ambiente
 * Solo muestra logs en desarrollo
 */

const isDevelopment = process.env.NODE_ENV === 'development' || 
                      process.env.REACT_APP_DEBUG === 'true' ||
                      window.location.hostname === 'localhost';

export const debugLog = (...args) => {
  if (isDevelopment) {
    console.log(...args);
  }
};

export const debugWarn = (...args) => {
  if (isDevelopment) {
    console.warn(...args);
  }
};

export const debugError = (...args) => {
  if (isDevelopment) {
    console.error(...args);
  }
};

export const debugTable = (data) => {
  if (isDevelopment) {
    console.table(data);
  }
};

export const debugGroup = (label, callback) => {
  if (isDevelopment) {
    console.group(label);
    callback();
    console.groupEnd();
  }
};
